import useCommon from "@/shared/hooks/useCommon";
import useDocumentTitle from "@/shared/hooks/useDocumentHook";
import Loader from "./Loader";
import useLiveOrdersHook from "./useLiveOrdersHook";

export const modalNameEnum = {
  TIME_MODAL: "TIME_MODAL",
  ORDER_TRACKER_SETTINGS_MODAL: "ORDER_TRACKER_SETTINGS_MODAL",
  PRINTER_SETTINGS_MODAL: "PRINTER_SETTINGS_MODAL",
  AUTO_ACCEPT_ORDER_MODAL: "AUTO_ACCEPT_ORDER_MODAL",
  ORDER_MODAL: "ORDER_MODAL",
  NEW_ORDER_MODAL: "NEW_ORDER_MODAL",
  ORDER_MAP: "ORDER_MAP",
};

const LivePage = () => {
  const t = useCommon();
  useDocumentTitle(t("layout.liveFollow"));
  const orders = useLiveOrdersHook();

  return <Loader data={orders} />;
};

export default LivePage;
